import { useLocation } from "preact-iso";
import { transact, tx, useAuth, useQuery } from "./db.ts";
import { ErrorMessage, Loading } from "./uiComponents.tsx";
import { primaryColor, t } from "./theme.ts";

export const SnapshotsView = () => {
  const th = t();
  const { user } = useAuth();
  const { route } = useLocation();

  // Query snapshots where the current user is an admin of the linked account
  const { isLoading, data, error } = useQuery({
    accounts: {
      snapshots: {},
    },
  });

  if (isLoading) return <Loading text="Loading snapshots" fullPage />;
  if (error) return <ErrorMessage error={error} />;

  // Extract and sort snapshots belonging to the user's accounts
  // deno-lint-ignore no-explicit-any
  const snapshots = (data?.accounts || [])
    .flatMap((a: any) => a.snapshots || [])
    .sort((a: any, b: any) => (b.createdAt || 0) - (a.createdAt || 0));

  if (snapshots.length === 0) {
    return (
      <div style={{ padding: 20, color: th.textMuted }}>
        No snapshots found. You can create one from a conversation's action
        menu.
      </div>
    );
  }

  return (
    <div style={{ padding: 20, maxWidth: 800, margin: "0 auto" }}>
      <h2 style={{ color: primaryColor(), marginBottom: 20 }}>
        Your Snapshots
      </h2>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {snapshots.map((s) => (
          <div
            key={s.id}
            style={{
              padding: 16,
              background: th.cardBgAlt,
              borderRadius: 8,
              border: `1px solid ${th.borderLight}`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              <div
                style={{
                  color: th.text,
                  fontWeight: "bold",
                  marginBottom: 4,
                }}
              >
                {new Date(s.createdAt).toLocaleString()}
              </div>
              <div style={{ fontSize: 13, color: th.textMuted }}>
                Conversation ID: {s.conversationId || "N/A"}
              </div>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button
                className="compact-button"
                onClick={() => route(`/snapshot/${s.id}`)}
              >
                View
              </button>
              <button
                className="compact-button"
                style={{
                  background: th.dangerBg,
                  color: "#ff8888",
                  borderColor: th.dangerBorder,
                }}
                onClick={() => {
                  if (confirm("Delete this snapshot?")) {
                    transact(tx.snapshots[s.id].delete());
                  }
                }}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
